/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TransportProtocol {
    Udp = 0,
    Tcp = 1,
    Default = 2,
}
